import React from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

function BackButton() {
  //1)Data
  const { t } = useTranslation();
  const ApplicationSettings = useSelector(
    (state) => state.ApplicationSettings.value
  );
  return (
    <div className="fixed bottom-0 left-0 w-full px-3 py-2 bg-white ">
      <Link
        to={"/Dashboard"}
        className=" bg-gray-300 Primary_Light_Background text-gray-800 font-bold py-3 px-4 rounded-lg inline-flex justify-center items-center w-full"
      >
        <ArrowBackIcon />
        <span className="ml-2 Primary_Dark_Text">{t("ΕΠΙΣΤΡΟΦΗ")}</span>
      </Link>
    </div>
  );
}

export default BackButton;
